import { render, staticRenderFns } from "./PrivacyPolicySummary.vue?vue&type=template&id=ac4b1062&scoped=true"
import script from "./PrivacyPolicySummary.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicySummary.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicySummary.vue?vue&type=style&index=0&id=ac4b1062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4b1062",
  null
  
)

export default component.exports